import React, { Component } from 'react'

import SocialLinks from './SocialLinks'

class ContactAddress extends Component {
    logo() {
        const { data, logoInverted } = this.props
        const { logo, logo_invert } = data
   
        return logoInverted ? logo_invert : logo
    }

    render() {
        const { data, content } = this.props
        return (
            <div className="address sm-center">
                <div className="pull-left sm-center" style={{ maxWidth: '66%' }}><span><img src={this.logo()} className="img-responsive" alt="" /><br /><br /></span></div>
                <div className="divider divider--sm"></div>
                {content.address && (<div className="text-left sm-center">
                    <strong>Naše adresa:</strong><br /> {content.address.street}
                    <br /> {content.address.city}
                    <br /> {content.address.psc} </div>)}
                <div className="divider divider--sm"></div>
                {content.telefon && (<div className="text-left">
                    <strong>Telefon:</strong> <a href={`tel:${data.phone.replace('+', '00').replace(' ', '')}`}>{data.phone}</a> </div>)}
                <div className="divider divider--sm"></div>
                {content.email && (<div className="text-left">
                    <strong>E-mail:</strong> <a href={`mailto:${content.email}`}>{content.email}</a></div>)}
                <div className="divider divider--md"><br /></div>
                <div className="social-links lg">
                    <SocialLinks />
                </div>
                <br /><br />
            </div>
        )
    }
}

export default ContactAddress


// WEBPACK FOOTER //
// ./src/components/ContactAddress.js